import styled, { css } from 'styled-components';
import { IconGlyph } from '@/app/common/icons/MaskIcon';

export const BasicBannerContainer = styled.div<{ isPill: boolean; isMobile: boolean }>`
  padding: 8px 16px;
  background-color: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: 100%;

  svg,
  [data-library-icon] {
    flex-shrink: 0;
    width: 14px;
    height: 14px;
  }

  ${({ isPill }) =>
    isPill &&
    css`
      background-color: unset;
      border-radius: unset;
      padding: 0;
      height: 100%;

      svg,
      ${IconGlyph} {
        width: 20px;
        height: 20px;
        margin-left: 4px !important;
      }
    `}

  .list-container & {
    ${({ isMobile }) =>
      isMobile &&
      css`
        margin-bottom: 24px;
      `}
  }
`;

export const BasicBannerImageContainer = styled.div`
  margin-right: 16px;
`;

export const BasicBannerTextContainer = styled.div`
  width: 100%;
  text-align: left;
`;

export const BasicBannerHeadingContainer = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  margin-right: 16px;
`;

export const BasicBannerDescriptionContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;

  button {
    border: none;
    padding: 0;
    margin: 0;
    background-color: unset;
    text-decoration: underline;
  }
`;
